module.exports = __webpack_public_path__ + "img/the-battle.3ed974de.jpg";